import React, { useCallback, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import Avatar from '../../../base/avatar/components/Avatar';
import { translate } from '../../../base/i18n/functions';
import ListItem from '../../../base/ui/components/web/ListItem';
import { ACTION_TRIGGER, AudioThinStateIcons, MEDIA_STATE, VideoThinStateIcons } from '../../constants';
import { RaisedHandIndicator } from './RaisedHandIndicator';
import { isMobileBrowser } from "../../../base/environment/utils";
import VideoMenuTriggerButton from "../../../filmstrip/components/web/VideoMenuTriggerButton";
import { THUMBNAIL_TYPE } from "../../../filmstrip/constants";
const useStyles = makeStyles()(theme => {
    return {
        nameContainer: {
            display: 'flex',
            flex: 1,
            overflow: 'hidden'
        },
        name: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        moderatorLabel: {
            fontFamily: 'Lato Regular',
            fontWeight: 'normal',
            fontSize: '15px',
            lineHeight: '22px',
            color: 'rgba(255, 255, 255, 0.3)',
            marginTop: '-2px',
            '&.is-mobile': {
                marginTop: 0,
                fontSize: '14px',
                lineHeight: '20px'
            }
        },
        avatar: {},
        avatarContainer: {
            marginRight: '8px',
            '&.is-mobile': {
                paddingLeft: '16px',
            }
        }
    };
});
/**
 * A component representing a participant entry in ParticipantPane and Lobby.
 *
 * @param {IProps} props - The props of the component.
 * @returns {ReactNode}
 */
function ParticipantItem({ actionsTrigger = ACTION_TRIGGER.HOVER, audioMediaState = MEDIA_STATE.NONE, children, disableModeratorIndicator, displayName, isHighlighted, isModerator, local, onLeave, openDrawerForParticipant, overflowDrawer, participantID, raisedHand, isLobbyParticipantRequest, isVisitor, t, videoMediaState = MEDIA_STATE.NONE, youText }) {
    const onClick = useCallback(() => openDrawerForParticipant?.({
        participantID,
        displayName
    }), []);
    const { classes, cx } = useStyles();
    const isMobile = isMobileBrowser();
    const [popoverVisible, setPopoverVisible] = useState(false);
    const showPopover = useCallback(() => setPopoverVisible(true), []);
    const hidePopover = useCallback(() => setPopoverVisible(false), []);
    const icon = (React.createElement(Avatar, { className: classes.avatar, displayName: displayName, participantId: participantID, size: isMobile ? 44 : 40 }));
    const text = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.nameContainer },
            React.createElement("div", { className: classes.name }, displayName),
            local ? React.createElement("span", null,
                "\u00A0(",
                youText,
                ")") : null),
        isModerator && React.createElement("div", { className: cx(classes.moderatorLabel, isMobile && 'is-mobile') }, t('videothumbnail.moderator')),
        (!isModerator && !isLobbyParticipantRequest && !isVisitor) && React.createElement("div", { className: classes.moderatorLabel }, t('videothumbnail.member')),
        isVisitor && React.createElement("div", { className: classes.moderatorLabel }, t('participantsPane.visitor')),
        isLobbyParticipantRequest && React.createElement("div", { className: classes.moderatorLabel }, t('participantsPane.lobbyRequest'))));
    const indicators = (React.createElement(React.Fragment, null,
        raisedHand && React.createElement(RaisedHandIndicator, null),
        VideoThinStateIcons[videoMediaState],
        AudioThinStateIcons[audioMediaState]));
    return (React.createElement(React.Fragment, null,
        React.createElement(ListItem, { actions: children, hideActions: local, icon: icon, iconClassName: cx(classes.avatarContainer, isMobile && 'is-mobile'), id: `participant-item-${participantID}`, indicators: indicators, isHighlighted: isHighlighted, onClick: local && isMobile ? (popoverVisible ? hidePopover : showPopover) : !local && overflowDrawer ? onClick : undefined, onMouseLeave: onLeave, textChildren: text, trigger: actionsTrigger }),
        local && isMobile && (React.createElement(VideoMenuTriggerButton, { hidePopover: hidePopover, local: local, participantId: participantID, popoverVisible: popoverVisible, showPopover: showPopover, thumbnailType: THUMBNAIL_TYPE.TILE, visible: false }))));
}
export default translate(ParticipantItem);
